import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgFlagCanadaGlyph from './svgs/FlagCanadaGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var flagCanadaGlyph = (props => useIcon(SvgFlagCanadaGlyph, SvgFlagCanadaGlyph, props));

export { flagCanadaGlyph as default };
